import { PurchaseActions, PurchaseActionTypes } from '../actions/purchase.actions';
import { OrderHistory, PurchaseOtp, PayPalAgreement } from '../purchase.model';

export interface PurchaseState {
  isLoaded: boolean;
  isLoading: boolean;
  entities: OrderHistory[];
}

export const initialState: PurchaseState = {
  isLoaded: false,
  isLoading: false,
  entities: []
};

export interface PurchaseOtpState {
  isLoaded: boolean;
  isLoading: boolean;
  entities: PurchaseOtp;
}

export const initialPurchaseOtpState: PurchaseOtpState = {
  isLoaded: false,
  isLoading: false,
  entities: { otp: '' }
};

export interface PayPalAgreementApprovalUrlState {
  isLoaded: boolean;
  isLoading: boolean;
  approval_url: string;
}

export const initialPayPalAgreementApprovalUrlState: PayPalAgreementApprovalUrlState = {
  isLoaded: false,
  isLoading: false,
  approval_url: ''
};

export function reducer(state = initialState, action: PurchaseActions): PurchaseState {
  switch (action.type) {

    case PurchaseActionTypes.GET_PURCHASE:
      return {...state, isLoading: true, isLoaded: false };
    case PurchaseActionTypes.GET_PURCHASE_SUCCESS:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload };
    case PurchaseActionTypes.GET_PURCHASE_FAIL:
      return {...state, isLoading: false, isLoaded: true, entities: [] };
    default:
      return state;
  }
}
export function purchaseOtpreducer(state = initialPurchaseOtpState, action: PurchaseActions): PurchaseOtpState {
  switch (action.type) {

    case PurchaseActionTypes.GET_PURCHASE_OTP:
      return {...state, isLoading: true, isLoaded: false };
    case PurchaseActionTypes.GET_PURCHASE_OTP_SUCCESS:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload };
    case PurchaseActionTypes.GET_PURCHASE_OTP_FAIL:
      return {...state, isLoading: false, isLoaded: true, entities: {otp: ''} };
    default:
      return state;
  }
}

export function PayPalAgreementApprovalUrlReducer(state = initialPayPalAgreementApprovalUrlState, action: PurchaseActions):
 PayPalAgreementApprovalUrlState {
  switch (action.type) {

    case PurchaseActionTypes.GetPayPalAgreementApprovalUrl:
      return {...state, isLoading: true, isLoaded: false, approval_url: '' };
    case PurchaseActionTypes.GetPayPalAgreementApprovalUrlSuccess:
      return {...state, isLoading: false, isLoaded: true, approval_url: action.payload.approval_url };
    case PurchaseActionTypes.GetPayPalAgreementApprovalUrlFailure:
      return {...state, isLoading: false, isLoaded: true, approval_url: '' };
    case PurchaseActionTypes.ResetPayPalAgreementApprovalUrl:
      return {...state, isLoading: false, isLoaded: false, approval_url: '' };
    default:
      return state;
  }
}

